import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../../Components/CustomInputs/CustomInput";
import { useScrollToTopErrorInput } from "../../../../../CustomHooks/useScrollToTopErrorInput";
import { updateFifthStepAgentFields } from "../../../../../redux/reducers/claimReducer";
import { shouldRenderSpecField } from "../../../../../redux/reducers/visibilityMatrixesReducer";
import { StoreType } from "../../../../../redux/store/store";

const AgentEmailField = () => {
   const dispatch = useDispatch();
   const value = useSelector((state: StoreType) => state.claimState.reportModel.agentModel.agentEmail);
   const consent = useSelector((state: StoreType) => state.claimState.reportModel.gdprAgreement);
   const error = useSelector((state: StoreType) => state.authState.agentErorrs.agentEmail);
   const visibility = useSelector((state: StoreType) => state.visibilityMatrixesState);
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, "AgentEmail");

   return (
      <CustomInput
         labelText="E-mail poradce (nepovinné)"
         placeholderText="Uveďte e-mail poradce"
         value={value || ""}
         onChange={(event) => dispatch(updateFifthStepAgentFields({ field: "agentEmail", value: event.target.value }))}
         validationText={error}
         dependencyValue={shouldRenderSpecField("GeneralFields", "AgentEmail", visibility) && consent}
         inputRef={ref}
      />
   );
};

export default AgentEmailField;
